import {
  AnchorButton,
  Button,
  Card,
  Collapse,
  ControlGroup,
  EditableText,
  Elevation,
  Icon,
  InputGroup,
  NonIdealState,
  NumericInput,
  Spinner,
  Tag,
  Dialog,
  Classes,
} from "@blueprintjs/core";
import React from "react";
import {
  apiCallPost,
  calculateRatesPaise,
  indianRupee,
  niceDate,
} from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import _ from "lodash";
import ReactList from "react-list";
import MasterEntity from "../v2/MasterEntity";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import MasterRow from "../v2/MasterRow";
import { withRouter } from "react-router";
import ColumnDefs from "../v2/ColumnDefs";
import LedgerCreator from "../v2/LedgerCreator";
import LedgerSearchTopBar from "../v2/LedgerSearchTopBar";
import SxReportTopBar from "../v2/SxReportTopBar";
import SxSearch from "../v2/SxSearch";
import SingleIDSelectWrapper from "../utils/SingleIDSelectWrapper";
import { DateRangeInput } from "@blueprintjs/datetime";
import moment from "moment";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import MultiSelectWrapper from "../utils/MultiSelectWrapper";
import { nanoid } from "nanoid";

class SearchDisplayHOC extends React.Component {
  today = moment().startOf("day").toDate();
  state = {
    isCreatingNew: false,
    isLoading: true,
    loadedItems: [],
    loadedSites: [],
    loadedDocs: [],
    searchText: "",
    showAll: "CURRENT",
    copyPayload: null,
    ledgerSearchMode: "ALL",
    itemCanBeSold: false,
    isOptical: false,
    isPharmacy: false,

    surgeonId: null,
    surgeonName: null,
    validRange: [this.today, this.today],
    site: null,

    scheduledSite: "",
    panelName: "",
    panelObject: null,
    searchResults: [],
    searching: false,
    panelSite: "",
    surgeryName: "",

    collapsed: [],

    cashRates: [],
    payorRates: [],
    openDailog: false,
  };
  componentDidMount() {
    this.getSites();
    if (["materialRequests", "purchaseOrder"].includes(this.props.entityType)) {
      this.setState({ showAll: "DRAFT" });
    }
  }
  getSites = async () => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/rai/${this.props.authStore.prefix}/getAllSites`,
        {}
      );

      this.setState(
        {
          loadedSites: res,
        },
        () => this.getDocs()
      );
    } catch (err) {
      cogoToast.error(
        `We ran into an error while loading sites. Please try again. If this error persists, please contact support immediately.`
      );
    }
  };
  getDocs = async () => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/rai/${this.props.authStore.prefix}/getAllConsultants`,
        {}
      );

      this.setState(
        {
          loadedDocs: _.sortBy(res, "name"),
        },
        () => {
          if (
            this.props.match &&
            this.props.match.params &&
            this.props.match.params.searchId
          ) {
            this.search(this.props.match.params.searchId);
          } else {
            this.getAll();
          }
        }
      );
    } catch (err) {
      cogoToast.error(
        `We ran into an error while loading sites. Please try again. If this error persists, please contact support immediately.`
      );
    }
  };
  getAll = async () => {
    if (
      this.props.entityType === "sxBooking" &&
      this.props.renderType === "TABLE"
    ) {
      try {
        cogoToast.loading(`Fetching ${_.lowerCase(this.props.displayTitle)}s`);
        this.setState({ isLoading: true });
        let res = await apiCallPost(
          `/booking-sx/${this.props.authStore.prefix}/sxBooking/search`,
          { sxDateIn: [new Date(), new Date()] }
        );

        this.setState({
          isLoading: false,
          loadedItems: res,
        });
        cogoToast.success(
          `Loaded ${res.length} ${_.lowerCase(this.props.displayTitle)}${
            res.length === 1 ? "" : "s"
          }.`
        );
        return;
      } catch (err) {
        cogoToast.error(
          `We ran into an error while loading ${_.lowerCase(
            this.props.displayTitle
          )}s. Please try again. If this error persists, please contact support immediately.`
        );
      } finally {
        this.setState({ isLoading: false });
      }
    }
    if (this.props.renderType === "GRID") {
      try {
        cogoToast.loading(`Fetching ${_.lowerCase(this.props.displayTitle)}s`);
        this.setState({ isLoading: true });

        let res = await apiCallPost(
          `/booking-sx/${this.props.authStore.prefix}/sxBooking/report/${
            this.props.entityType == "sxBookingRegisterReport"
              ? "sxBookingReport"
              : this.props.entityType
          }/`,
          {}
        );

        this.setState({
          isLoading: false,
          loadedItems: res,
        });
        cogoToast.success(
          `Loaded ${res.length} ${_.lowerCase(this.props.displayTitle)}${
            res.length === 1 ? "" : "s"
          }.`
        );
      } catch (err) {
        cogoToast.error(
          `We ran into an error while loading ${_.lowerCase(
            this.props.displayTitle
          )}s. Please try again. If this error persists, please contact support immediately.`
        );
      } finally {
        this.setState({ isLoading: false });
      }
    } else {
      try {
        cogoToast.loading(`Fetching ${_.lowerCase(this.props.displayTitle)}s`);
        this.setState({ isLoading: true });
        if (this.props.entityType !== "sxSurgeonSchedule") {
          let res = await apiCallPost(
            `/${
              this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"
            }/${this.props.authStore.prefix}/${this.props.entityType}/getAll`,
            {}
          );

          this.setState({
            isLoading: false,
            loadedItems: res,
          });
          cogoToast.success(
            `Loaded ${res.length} ${_.lowerCase(this.props.displayTitle)}${
              res.length === 1 ? "" : "s"
            }.`
          );
        }
      } catch (err) {
        cogoToast.error(
          `We ran into an error while loading ${_.lowerCase(
            this.props.displayTitle
          )}s. Please try again. If this error persists, please contact support immediately.`
        );
      } finally {
        this.setState({ isLoading: false });
      }
    }
  };
  search = async (searchId = null) => {
    try {
      cogoToast.loading(`Searching ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isSearching: true, isBusy: true });
      let payload = { prefix: this.state.searchText || "" };
      let {
        surgeonId,
        scheduledSite,
        validRange,
        panelName,
        panelSite,
        surgeryName,
      } = this.state;
      if (this.props.entityType === "sxSurgeonSchedule") {
        if (surgeonId) {
          payload["surgeonId"] = surgeonId;
        }
        if (scheduledSite !== "") {
          payload["site"] = scheduledSite;
        }
        if (validRange) {
          payload["validRange"] = validRange;
        }
      }
      if (this.props.entityType === "sxPriceMaster") {
        if (panelName) {
          payload["panelName"] = panelName;
        }
        if (panelSite !== "") {
          payload["panelSite"] = panelSite;
        }
        if (surgeryName) {
          payload["prefix"] = surgeryName;
        }
      }
      if (searchId) {
        payload["itemId"] = searchId;
      }
      if (["item", "prices"].includes(this.props.entityType)) {
        payload["showWhich"] = this.state.showAll;
      }
      if (
        this.props.entityType === "item" &&
        this.props.renderType === "TABLE"
      ) {
        payload["showWhich"] = "CURRENT";
        payload["itemCanBeSold"] = true;
        payload["isOptical"] = this.state.isOptical;
        payload["isPharmacy"] = this.state.isPharmacy;
      }
      if (
        ["materialRequests", "purchaseOrder"].includes(this.props.entityType)
      ) {
        payload["state"] = searchId
          ? "SUBMITTED"
          : this.state.showAll === "ALL"
          ? undefined
          : this.state.showAll;
      }
      let res = await apiCallPost(
        `/${this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"}/${
          this.props.authStore.prefix
        }/${this.props.entityType}/search`,
        payload
      );
      this.setState({
        isSearching: false,
        isLoading: false,
        loadedItems: res,
      });
      cogoToast.success(
        `Found ${res.length} result${res.length === 1 ? "" : "s"}.`
      );
    } catch (err) {
      cogoToast.error(
        `We ran into an error while searching ${_.lowerCase(
          this.props.displayTitle
        )}s. Please try again. If this error persists, please contact support immediately.`
      );
    } finally {
      this.setState({ isSearching: false, isBusy: false, isLoading: false });
    }
  };
  searchPanel = async (string) => {
    if (!string) {
      this.setState({ searchResults: [] });
      return;
    }
    try {
      this.setState({ searching: true });

      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/sxPaymentPanelMaster/search`,
        { prefix: string }
      );
      this.setState({ searchResults: res, searching: false });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
    }
  };
  new = async () => {
    if (this.props.entityType === "ledger") {
      this.setState({ showNewLedgerCreator: !this.state.showNewLedgerCreator });
      return;
    }
    if (this.props.entityType === "sxPaymentPanelMaster") {
      cogoToast.loading(`Creating new ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isCreatingNew: true });
      try {
        let res = await apiCallPost(
          `/${
            this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"
          }/${this.props.authStore.prefix}/${this.props.entityType}/createNew`,
          {}
        );
        this.setState({
          isCreatingNew: false,
          loadedItems: [res, ...this.state.loadedItems],
        });
        cogoToast.success(
          `Done. Please edit the newly created ${_.lowerCase(
            this.props.displayTitle
          )} and save.`
        );
        return;
      } catch (err) {
        cogoToast.error(`Error: ${err}`);
        this.setState({
          isCreatingNew: false,
        });
        return;
      }
    }
    if (this.props.entityType === "sxSurgeonSchedule") {
      if (this.state.surgeonId === null) {
        cogoToast.error("Please select a surgeon to proceed.");
        return;
      }
      if (this.state.scheduledSite === "") {
        cogoToast.error("Please select a site to proceed.");
        return;
      }

      if (this.state.validRange.length !== 2) {
        cogoToast.error("Please select a valid date range to proceed.");
        return;
      }

      cogoToast.loading(`Creating new ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isCreatingNew: true });
      let res = await apiCallPost(
        `/${this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"}/${
          this.props.authStore.prefix
        }/${this.props.entityType}/createNew`,
        {
          site: this.state.scheduledSite,
          surgeonId: this.state.surgeonId,
          surgeonName: this.state.surgeonName,
          validRange: this.state.validRange,
        }
      );
      this.setState({
        isCreatingNew: false,
        loadedItems: [res, ...this.state.loadedItems],
      });
      cogoToast.success(
        `Done. Please edit the newly created ${_.lowerCase(
          this.props.displayTitle
        )} and save.`
      );
      return;
    }
    if (this.props.entityType === "sxPriceMaster") {
      if (this.state.panelName === null || this.state.panelName === "") {
        cogoToast.error("Please select a panel name to proceed.");
        return;
      }
      if (this.state.panelSite === "") {
        cogoToast.error("Please select a site to proceed.");
        return;
      }

      cogoToast.loading(`Creating new ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isCreatingNew: true });
      try {
        let res = await apiCallPost(
          `/${
            this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"
          }/${this.props.authStore.prefix}/${this.props.entityType}/createNew`,
          {
            panelSite: this.state.panelSite,
            panelName: this.state.panelName,
            surgeryName: this.state.surgeryName ? this.state.surgeryName : null,
          }
        );
        this.setState({
          isCreatingNew: false,
          loadedItems: [res, ...this.state.loadedItems],
          panelSite: null,
          panelName: null,
          surgeryName: null,
        });
        cogoToast.success(
          `Done. Please edit the newly created ${_.lowerCase(
            this.props.displayTitle
          )} and save.`
        );
        return;
      } catch (err) {
        cogoToast.error(
          `A record with the same panel site, panel name and surgery name already exists.`
        );
        this.setState({
          isCreatingNew: false,
        });
        return;
      }
    }
    if (this.props.entityType === "sxAnaesthesiaPriceMaster") {
      // if (this.state.panelName === null) {
      //   cogoToast.error("Please select a panel name to proceed.");
      //   return;
      // }
      // if (this.state.panelSite === "") {
      //   cogoToast.error("Please select a site to proceed.");
      //   return;
      // }

      cogoToast.loading(`Creating new ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isCreatingNew: true });
      try {
        let res = await apiCallPost(
          `/${
            this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"
          }/${this.props.authStore.prefix}/${this.props.entityType}/createNew`
        );
        this.setState({
          isCreatingNew: false,
          loadedItems: [res, ...this.state.loadedItems],
        });
        cogoToast.success(
          `Done. Please edit the newly created ${_.lowerCase(
            this.props.displayTitle
          )} and save.`
        );
        return;
      } catch (err) {
        cogoToast.error(
          `A record with the same anaesthesiaType and site already exists.`
        );
        this.setState({
          isCreatingNew: false,
        });
        return;
      }
    }

    let stateObj = this.state.loadedItems;
    let flagIfNewEntityAlreadyOpen = false;
    for (var i = 0; i < stateObj.length; i++) {
      if (stateObj[i].isShell) {
        flagIfNewEntityAlreadyOpen = true;
      }
    }
    if (flagIfNewEntityAlreadyOpen) {
      cogoToast.error(
        `There's already a newly created shell ${_.lowerCase(
          this.props.displayTitle
        )} open. Please edit that to proceed.`
      );
      return;
    }
    try {
      cogoToast.loading(`Creating new ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isCreatingNew: true });
      let res = await apiCallPost(
        `/${this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"}/${
          this.props.authStore.prefix
        }/${this.props.entityType}/createNew`,
        {}
      );
      this.setState({
        isCreatingNew: false,
        loadedItems: [res, ...this.state.loadedItems],
      });
      cogoToast.success(
        `Done. Please edit the newly created ${_.lowerCase(
          this.props.displayTitle
        )} and save.`
      );
      if (this.props.entityType === "sxBooking") {
        window.open(`/sx/${res._id}`, "_blank").focus();
      }
    } catch (err) {
      cogoToast.error(
        `We ran into an error while creating a new ${_.lowerCase(
          this.props.displayTitle
        )}. Please try again. If this error persists, please contact support immediately.`
      );
    } finally {
      this.setState({ isCreatingNew: false });
    }
  };
  checkIfUpdated = async (_id) => {
    try {
      cogoToast.loading(`Checking for simultaneous edits...`);
      this.setState({ isBusy: true });
      let res = await apiCallPost(
        `/${this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"}/${
          this.props.authStore.prefix
        }/${this.props.entityType}/getById`,
        { _id: _id }
      );
      let updated = res.updatedAt;
      let idx = _.findIndex(this.state.loadedItems, (each) => each._id === _id);
      if (this.state.loadedItems[idx].updatedAt !== updated) {
        this.setState({ isBusy: false });
        return { isUpdated: true, updatedDoc: res };
      } else {
        return { isUpdated: false, updatedDoc: res };
      }
    } catch (err) {
      this.setState({ isBusy: false });
      cogoToast.error(
        "We ran into an error checking for simultaneous edits to this document."
      );
      return false;
    }
  };
  update = async (payload) => {
    let ifUpdatedResponse = await this.checkIfUpdated(payload._id);

    if (ifUpdatedResponse.isUpdated) {
      let idx = _.findIndex(
        this.state.loadedItems,
        (x) => x._id === payload._id
      );

      if (this.state.loadedItems[idx].isShell) {
        //someone has already edited the shell ==> create new & update that
        // first create a new shell doc
        try {
          this.setState({ isCreatingNew: true });
          let resNew = await apiCallPost(
            `/${
              this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"
            }/${this.props.authStore.prefix}/${
              this.props.entityType
            }/createNew`,
            {}
          );

          try {
            let res = await apiCallPost(
              `/${
                this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"
              }/${this.props.authStore.prefix}/${this.props.entityType}/update`,
              { _id: resNew._id, doc: payload }
            );
            let list = this.state.loadedItems;
            list[idx] = ifUpdatedResponse.updatedDoc;
            this.setState({
              loadedItems: [res, ...list],
              isBusy: false,
              isCreatingNew: false,
            });
          } catch (err) {
            this.setState({ isBusy: false, isCreatingNew: false });

            cogoToast.error("We ran into an error updating the document.");
          }
        } catch (err) {
          this.setState({ isBusy: false });
          cogoToast.error(
            "We ran into an error creating a new shell document."
          );
        }
      } else {
        cogoToast.error("This document has been edited by someone else.");
        cogoToast.loading("Updating the document with the latest changes.");
        let list = this.state.loadedItems;
        list[idx] = ifUpdatedResponse.updatedDoc;
        this.setState({ loadedItems: list });
        cogoToast.success(
          "Done. Please edit the document again. We are sorry for the inconvenience."
        );
      }
      return;
    }
    try {
      cogoToast.loading(`Updating ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isBusy: true });
      let res = await apiCallPost(
        `/${this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"}/${
          this.props.authStore.prefix
        }/${this.props.entityType}/update`,
        { _id: payload._id, doc: payload }
      );
      let idx = _.findIndex(
        this.state.loadedItems,
        (each) => each._id === payload._id
      );
      let stateObj = this.state.loadedItems;
      stateObj[idx] = res;
      this.setState({
        loadedItems: stateObj,
      });
      cogoToast.success(
        `Changes saved to ${_.lowerCase(this.props.displayTitle)} successfully.`
      );
    } catch (err) {
      cogoToast.error(
        `We ran into an error while updating the ${_.lowerCase(
          this.props.displayTitle
        )}. Please try again. If this error persists, please contact support immediately.`
      );
    } finally {
      this.setState({ isBusy: false });
    }
  };
  delete = async (id) => {
    let ifUpdatedResponse = await this.checkIfUpdated(id);
    if (ifUpdatedResponse.isUpdated) {
      cogoToast.error(
        "This document has been edited by someone else since you loaded it."
      );
      cogoToast.loading("Updating the document with the latest changes.");
      let idx = _.findIndex(this.state.loadedItems, (x) => x._id === id);
      let list = this.state.loadedItems;
      list[idx] = ifUpdatedResponse.updatedDoc;
      this.setState({ loadedItems: list });
      cogoToast.success(
        "Done. Please edit or delete the document again. We are sorry for the inconvenience."
      );
      return;
    }
    try {
      cogoToast.loading(`Deleting ${_.lowerCase(this.props.displayTitle)}`);
      this.setState({ isBusy: true });
      await apiCallPost(
        `/${this.props.entityType === "sxBooking" ? "booking-sx" : "meta-sx"}/${
          this.props.authStore.prefix
        }/${this.props.entityType}/delete`,
        { _id: id }
      );
      let idx = _.findIndex(this.state.loadedItems, (each) => each._id === id);
      let stateObj = this.state.loadedItems;
      stateObj.splice(idx, 1);
      cogoToast.success(
        `Deleted ${_.lowerCase(this.props.displayTitle)} successfully.`
      );
      this.setState({ loadedItems: stateObj });
    } catch (err) {
      cogoToast.error(
        `We ran into an error while deleting the ${_.lowerCase(
          this.props.displayTitle
        )}. Please try again. If this error persists, please contact support immediately.`
      );
    } finally {
      this.setState({ isBusy: false });
    }
  };
  renderListOrTable = () => {
    if (!this.state.loadedItems.length) {
      return (
        <NonIdealState
          icon="ring"
          title={`No results.`}
          description={`No ${_.lowerCase(
            this.props.displayTitle
          )}s loaded. You can try searching to get some results, or create new ones.`}
        />
      );
    }
    if (this.props.renderType === "LIST") {
      return <>{this.renderList()}</>;
    }
    if (this.props.entityType === "sxPriceMaster") {
      return <>{this.renderCollapsablePanel()}</>;
    }
    if (this.props.renderType === "TABLE") {
      return <>{this.renderTable()}</>;
    }
    if (this.props.renderType === "GRID") {
      return (
        <div>
          <ColumnDefs
            loadedItems={this.state.loadedItems}
            entityType={this.props.entityType}
          />
        </div>
      );
    }
  };

  foundCashRate = (item, payorItem) => {
    const cashRates = item.cashRates || [];
    let foundCashRate = null;
    for (let i = 0; i < cashRates.length; i++) {
      for (let cashRateBranch of cashRates[i].branches) {
        if (payorItem.branches.includes(cashRateBranch)) {
          foundCashRate = cashRates[i];
          break;
        }
      }
    }
    return foundCashRate;
  };
  removePayorItem = (index, payorIndex) => {
    const loadedItemsUpdated = _.clone(this.state.loadedItems);
    loadedItemsUpdated[index].payorRates.splice(payorIndex, 1);
    this.setState({
      loadedItems: loadedItemsUpdated,
      changed: true,
    });
  };
  renderCollapsablePanel = () => {
    let each = this.state.loadedItems;

    return each.map((item, index) => (
      <div key={index} style={{ marginBottom: "20px" }}>
        <Collapse isOpen={!this.state.collapsed[index]}>
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Procedure : {item.entityName}
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => {
                const collapsed = [...this.state.collapsed];
                collapsed[index] = !collapsed[index];
                this.setState({ collapsed });
              }}
            />
          </Card>
        </Collapse>
        <Collapse isOpen={this.state.collapsed[index]}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <div
              style={{
                marginBottom: "20px",
                marginRight: "10px",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              {/* <Tag large fill intent="primary">
                Procedure : {item.entityName}
              </Tag> */}

              <div>
                <EditableText
                  value={`${item.entityName}`}
                  onChange={(text) => {
                    const loadedItemsUpdated = _.clone(this.state.loadedItems);
                    loadedItemsUpdated[index].entityName = text;

                    this.setState({
                      loadedItems: loadedItemsUpdated,
                      changed: true,
                    });
                  }}
                />

                <Button
                  icon="double-chevron-down"
                  outlined
                  onClick={() => {
                    const collapsed = [...this.state.collapsed];
                    collapsed[index] = !collapsed[index];
                    this.setState({ collapsed });
                  }}
                />
              </div>
              <div>
                <AnchorButton
                  icon="delete"
                  onClick={() => {
                    this.setState({ openDailog: true });
                    // this.delete(this.state.loadedItems[index]._id);
                  }}
                ></AnchorButton>
              </div>
            </div>
            <Tag
              large
              interactive
              onClick={() => {
                const loadedItemsUpdated = _.clone(this.state.loadedItems);
                loadedItemsUpdated[index].hasImplant =
                  !this.state.loadedItems[index].hasImplant;

                this.setState({
                  loadedItems: loadedItemsUpdated,
                  changed: true,
                });
              }}
              intent={this.state.loadedItems[index].hasImplant ? "success" : ""}
            >
              {this.state.loadedItems[index].hasImplant
                ? "Has Implant"
                : "Does not have Implant"}
            </Tag>

            <table
              className="bp3-html-table bp3-compact bp3-html-table-bordered bp3-html-table-striped"
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "95vw",
              }}
            >
              <thead>
                <tr>{this.renderTableHeaders()}</tr>
              </thead>
              <tbody>
                {item.cashRates.map((cashItem, cashRateIndex) => (
                  <tr
                    key={cashRateIndex}
                    className={this.state.changed ? "unsaved__bg" : ""}
                  >
                    <td>
                      <ControlGroup vertical>
                        <Tag minimal large intent="primary" multiline>
                          Cash
                        </Tag>
                      </ControlGroup>
                    </td>
                    <td>
                      <MultiSelectWrapper
                        intent="primary"
                        key={nanoid()}
                        items={this.state.loadedSites}
                        selectedItems={cashItem.branches}
                        onChange={(items) => {
                          const loadedItemsUpdated = _.clone(
                            this.state.loadedItems
                          );
                          loadedItemsUpdated[index].cashRates[
                            cashRateIndex
                          ].branches = items;

                          this.setState({
                            loadedItems: loadedItemsUpdated,
                            changed: true,
                          });
                        }}
                      />
                    </td>
                    <td>
                      <ControlGroup>
                        <NumericInput
                          style={{ width: "9em" }}
                          value={cashItem.procedureRatePaise / 100}
                          buttonPosition="NONE"
                          rightElement={<Tag minimal>₹</Tag>}
                          onValueChange={(number) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].cashRates[
                              cashRateIndex
                            ].procedureRatePaise = number * 100;

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                            });
                          }}
                          onBlur={() => {
                            item.cashRates = item.cashRates.map((each) => {
                              each.cashRatePaise =
                                each.implantRatePaise +
                                each.procedureRatePaise +
                                each.anaesthesiaRatePaise +
                                each.tissueRatePaise;
                              return each;
                            });
                            this.update(item);
                          }}
                        />
                      </ControlGroup>
                    </td>

                    <td>
                      <ControlGroup>
                        <NumericInput
                          style={{ width: "9em" }}
                          value={cashItem.implantRatePaise / 100}
                          buttonPosition="NONE"
                          rightElement={<Tag minimal>₹</Tag>}
                          onValueChange={(number) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].cashRates[
                              cashRateIndex
                            ].implantRatePaise = number * 100;

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                            });
                          }}
                          onBlur={() => {
                            item.cashRates = item.cashRates.map((each) => {
                              each.cashRatePaise =
                                each.implantRatePaise + each.procedureRatePaise;
                              return each;
                            });
                            this.update(item);
                          }}
                        />
                      </ControlGroup>
                    </td>
                    <td>
                      <ControlGroup>
                        <NumericInput
                          style={{ width: "9em" }}
                          value={cashItem.anaesthesiaRatePaise / 100}
                          buttonPosition="NONE"
                          rightElement={<Tag minimal>₹</Tag>}
                          onValueChange={(number) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].cashRates[
                              cashRateIndex
                            ].anaesthesiaRatePaise = number * 100;

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                            });
                          }}
                          onBlur={() => {
                            item.cashRates = item.cashRates.map((each) => {
                              each.cashRatePaise =
                                each.anaesthesiaRatePaise +
                                each.procedureRatePaise +
                                each.implantRatePaise +
                                each.tissueRatePaise;
                              return each;
                            });
                            this.update(item);
                          }}
                        />
                      </ControlGroup>
                    </td>
                    <td>
                      <ControlGroup>
                        <NumericInput
                          style={{ width: "9em" }}
                          value={
                            cashItem?.tissueRatePaise
                              ? cashItem?.tissueRatePaise / 100
                              : 0
                          }
                          buttonPosition="NONE"
                          rightElement={<Tag minimal>₹</Tag>}
                          onValueChange={(number) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].cashRates[
                              cashRateIndex
                            ].tissueRatePaise = number * 100;

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                            });
                          }}
                          // onBlur={() => {
                          //   item.cashRates = item.cashRates.map((each) => {
                          //     each.cashRatePaise =
                          //       each.implantRatePaise + each.procedureRatePaise;
                          //     return each;
                          //   });
                          //   this.update(item);
                          // }}
                        />
                      </ControlGroup>
                    </td>
                    <td>
                      <ControlGroup>
                        <NumericInput
                          style={{ width: "9em" }}
                          value={cashItem.gst ? cashItem.gst : 0}
                          buttonPosition="NONE"
                          rightElement={<Tag minimal>%</Tag>}
                          onValueChange={(number) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].cashRates[
                              cashRateIndex
                            ].gst = number;

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                            });
                          }}
                        />
                      </ControlGroup>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Button
              interactive
              style={{ marginTop: "10px" }}
              onClick={() => {
                item.cashRates.push({
                  cashRatePaise: 0,
                  procedureRatePaise: 0,
                  implantRatePaise: 0,
                  anaesthesiaRatePaise: 0,
                  tissueRatePaise: 0,
                  branches: [],
                  implant: 0,
                  gst: 0,
                });

                this.setState({ loadedItems: this.state.loadedItems });
              }}
            >
              Add
            </Button>

            <Button
              style={{ marginTop: "10px" }}
              onClick={() => {
                this.update(item);
              }}
            >
              Save Details
            </Button>

            <div
              style={{ overflowX: "auto", maxWidth: "100%", marginTop: "20px" }}
            >
              <table
                className="bp3-html-table bp3-compact bp3-html-table-bordered bp3-html-table-striped"
                style={{
                  minWidth: "1000px",
                  width: "auto",
                  tableLayout: "fixed",
                }}
              >
                <thead>
                  <tr>{this.renderTableHeaders("sxPriceMasterTable")}</tr>
                </thead>
                <tbody>
                  {item.payorRates.map((payorItem, payorIndex) => (
                    <tr
                      key={payorIndex}
                      className={this.state.changed ? "unsaved__bg" : ""}
                    >
                      <td>
                        <AsyncSelWrap
                          showSelectProp={true}
                          placeholder="Search..."
                          searching={this.state.searching}
                          items={this.state.searchResults.map((each) => {
                            return {
                              ...each,
                              item: each.entityName,
                            };
                          })}
                          selectedItem={
                            payorItem.entityName
                              ? { item: payorItem.entityName }
                              : null
                          }
                          update={(item) => this.searchPanel(item)}
                          onChange={(each) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].payorRates[
                              payorIndex
                            ].entityName = each.entityName;

                            // if (
                            //   payorItem.contractRateCapPaise !== 0 &&
                            //   (payorItem.targetDeltaPaise === 0 ||
                            //     payorItem.targetDeltaPaise) &&
                            //   (payorItem.discount === 0 ||
                            //     payorItem.discount) &&
                            //   (payorItem.gst === 0 || payorItem.gst)
                            // ) {
                            //   let foundCashRate = this.foundCashRate(
                            //     item,
                            //     payorItem
                            //   );

                            //   console.log("fff", foundCashRate);
                            //   if (!foundCashRate) {
                            //     return cogoToast.error(
                            //       "No cash rate found for the selected branches."
                            //     );
                            //   }
                            //   let finalRes = calculateRatesPaise(
                            //     foundCashRate,
                            //     loadedItemsUpdated[index].hasImplant,
                            //     payorItem.contractRateCapPaise,
                            //     payorItem.targetDeltaPaise,
                            //     payorItem.discount,
                            //     payorItem.gst,
                            //     payorItem.procedureChargeBeforeDisctPaise
                            //   );

                            //   loadedItemsUpdated[index].payorRates[
                            //     payorIndex
                            //   ].effectiveBillableRatePaise =
                            //     finalRes.effectiveBillablePaise;
                            //   loadedItemsUpdated[index].payorRates[
                            //     payorIndex
                            //   ].finalBillableRatePaise =
                            //     finalRes.finalBillablePaise;
                            //   loadedItemsUpdated[index].payorRates[
                            //     payorIndex
                            //   ].procedureChargeAfterDisctPaise =
                            //     finalRes.procedureChargeAfterDisctPaise;
                            //   loadedItemsUpdated[index].payorRates[
                            //     payorIndex
                            //   ].specialLessPaise = finalRes.specialLessPaise;
                            //   loadedItemsUpdated[index].payorRates[
                            //     payorIndex
                            //   ].implantCostNetPaise =
                            //     finalRes.implantCostNetPaise;
                            //   loadedItemsUpdated[index].payorRates[
                            //     payorIndex
                            //   ].implantCostShownPaise =
                            //     finalRes.implantCostShownPaise;
                            // }

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                              selectedItem: each.entityName,
                            });
                          }}
                        />
                      </td>
                      <td>
                        <InputGroup
                          style={{ width: "6em" }}
                          value={payorItem.payorAlias}
                          onChange={(event) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].payorRates[
                              payorIndex
                            ].payorAlias = event.target.value;

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                            });
                          }}
                        />
                      </td>

                      <td>
                        <MultiSelectWrapper
                          intent="primary"
                          key={nanoid()}
                          items={this.state.loadedSites}
                          selectedItems={payorItem.branches}
                          onChange={(items) => {
                            const loadedItemsUpdated = _.clone(
                              this.state.loadedItems
                            );
                            loadedItemsUpdated[index].payorRates[
                              payorIndex
                            ].branches = items;

                            if (
                              payorItem.contractRateCapPaise !== 0 &&
                              (payorItem.targetDeltaPaise === 0 ||
                                payorItem.targetDeltaPaise) &&
                              (payorItem.discount === 0 ||
                                payorItem.discount) &&
                              (payorItem.gst === 0 || payorItem.gst)
                            ) {
                              let foundCashRate = this.foundCashRate(
                                item,
                                payorItem
                              );
                              let finalRes = calculateRatesPaise(
                                foundCashRate,
                                loadedItemsUpdated[index].hasImplant,
                                payorItem.contractRateCapPaise,
                                payorItem.targetDeltaPaise,
                                payorItem.discount,
                                payorItem.gst,
                                payorItem.procedureChargeBeforeDisctPaise
                              );

                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].effectiveBillableRatePaise =
                                finalRes.effectiveBillablePaise;
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].finalBillableRatePaise =
                                finalRes.finalBillablePaise;
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].procedureChargeAfterDisctPaise =
                                finalRes.procedureChargeAfterDisctPaise;
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].specialLessPaise = finalRes.specialLessPaise;
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].implantCostNetPaise =
                                finalRes.implantCostNetPaise;
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].implantCostShownPaise =
                                finalRes.implantCostShownPaise;
                            }

                            this.setState({
                              loadedItems: loadedItemsUpdated,
                              changed: true,
                            });
                          }}
                        />
                      </td>
                      <td>
                        <ControlGroup>
                          <NumericInput
                            style={{ width: "6em" }}
                            value={
                              payorItem.contractRateCapPaise
                                ? payorItem.contractRateCapPaise / 100
                                : 0
                            }
                            buttonPosition="NONE"
                            rightElement={<Tag minimal>₹</Tag>}
                            onValueChange={(number) => {
                              const loadedItemsUpdated = _.clone(
                                this.state.loadedItems
                              );
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].contractRateCapPaise = number * 100;

                              if (
                                payorItem.contractRateCapPaise !== 0 &&
                                (payorItem.targetDeltaPaise === 0 ||
                                  payorItem.targetDeltaPaise) &&
                                (payorItem.discount === 0 ||
                                  payorItem.discount) &&
                                (payorItem.gst === 0 || payorItem.gst)
                              ) {
                                let foundCashRate = this.foundCashRate(
                                  item,
                                  payorItem
                                );
                                if (!foundCashRate) {
                                  return cogoToast.error(
                                    "No cash rate found for the selected branches."
                                  );
                                }
                                let finalRes = calculateRatesPaise(
                                  foundCashRate,
                                  loadedItemsUpdated[index].hasImplant,
                                  payorItem.contractRateCapPaise,
                                  payorItem.targetDeltaPaise,
                                  payorItem.discount,
                                  payorItem.gst,
                                  payorItem.procedureChargeBeforeDisctPaise
                                );

                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].effectiveBillableRatePaise =
                                  finalRes.effectiveBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].finalBillableRatePaise =
                                  finalRes.finalBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].procedureChargeAfterDisctPaise =
                                  finalRes.procedureChargeAfterDisctPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].specialLessPaise = finalRes.specialLessPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostNetPaise =
                                  finalRes.implantCostNetPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostShownPaise =
                                  finalRes.implantCostShownPaise;
                              }

                              this.setState({
                                loadedItems: loadedItemsUpdated,
                                changed: true,
                              });
                            }}
                          />
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup>
                          <NumericInput
                            style={{ width: "6em" }}
                            value={
                              payorItem.targetDeltaPaise
                                ? payorItem.targetDeltaPaise / 100
                                : 0
                            }
                            buttonPosition="NONE"
                            rightElement={<Tag minimal>₹</Tag>}
                            onValueChange={(number) => {
                              const loadedItemsUpdated = _.clone(
                                this.state.loadedItems
                              );
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].targetDeltaPaise = number * 100;

                              if (
                                payorItem.contractRateCapPaise !== 0 &&
                                (payorItem.targetDeltaPaise === 0 ||
                                  payorItem.targetDeltaPaise) &&
                                (payorItem.discount === 0 ||
                                  payorItem.discount) &&
                                (payorItem.gst === 0 || payorItem.gst)
                              ) {
                                let foundCashRate = this.foundCashRate(
                                  item,
                                  payorItem
                                );
                                if (!foundCashRate) {
                                  return cogoToast.error(
                                    "No cash rate found for the selected branches."
                                  );
                                }
                                let finalRes = calculateRatesPaise(
                                  foundCashRate,
                                  loadedItemsUpdated[index].hasImplant,
                                  payorItem.contractRateCapPaise,
                                  payorItem.targetDeltaPaise,
                                  payorItem.discount,
                                  payorItem.gst,
                                  payorItem.procedureChargeBeforeDisctPaise
                                );

                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].effectiveBillableRatePaise =
                                  finalRes.effectiveBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].finalBillableRatePaise =
                                  finalRes.finalBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].procedureChargeAfterDisctPaise =
                                  finalRes.procedureChargeAfterDisctPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].specialLessPaise = finalRes.specialLessPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostNetPaise =
                                  finalRes.implantCostNetPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostShownPaise =
                                  finalRes.implantCostShownPaise;
                              }

                              this.setState({
                                loadedItems: loadedItemsUpdated,
                                changed: true,
                              });
                            }}
                          />
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup vertical>
                          <Tag minimal large intent="primary" multiline>
                            {indianRupee(payorItem.effectiveBillableRatePaise)}
                          </Tag>
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup>
                          <NumericInput
                            style={{ width: "4em" }}
                            value={payorItem.discount ? payorItem.discount : 0}
                            buttonPosition="NONE"
                            rightElement={<Tag minimal>%</Tag>}
                            onValueChange={(number) => {
                              const loadedItemsUpdated = _.clone(
                                this.state.loadedItems
                              );
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].discount = number;

                              if (
                                payorItem.contractRateCapPaise !== 0 &&
                                (payorItem.targetDeltaPaise === 0 ||
                                  payorItem.targetDeltaPaise) &&
                                (payorItem.discount === 0 ||
                                  payorItem.discount) &&
                                (payorItem.gst === 0 || payorItem.gst)
                              ) {
                                let foundCashRate = this.foundCashRate(
                                  item,
                                  payorItem
                                );
                                if (!foundCashRate) {
                                  return cogoToast.error(
                                    "No cash rate found for the selected branches."
                                  );
                                }
                                let finalRes = calculateRatesPaise(
                                  foundCashRate,
                                  loadedItemsUpdated[index].hasImplant,
                                  payorItem.contractRateCapPaise,
                                  payorItem.targetDeltaPaise,
                                  payorItem.discount,
                                  payorItem.gst,
                                  payorItem.procedureChargeBeforeDisctPaise
                                );

                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].effectiveBillableRatePaise =
                                  finalRes.effectiveBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].finalBillableRatePaise =
                                  finalRes.finalBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].procedureChargeAfterDisctPaise =
                                  finalRes.procedureChargeAfterDisctPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].specialLessPaise = finalRes.specialLessPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostNetPaise =
                                  finalRes.implantCostNetPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostShownPaise =
                                  finalRes.implantCostShownPaise;
                              }

                              this.setState({
                                loadedItems: loadedItemsUpdated,
                                changed: true,
                              });
                            }}
                          />
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup>
                          <NumericInput
                            style={{ width: "4em" }}
                            value={payorItem.gst ? payorItem.gst : 0}
                            buttonPosition="NONE"
                            rightElement={<Tag minimal>%</Tag>}
                            onValueChange={(number) => {
                              const loadedItemsUpdated = _.clone(
                                this.state.loadedItems
                              );
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].gst = number;

                              if (
                                payorItem.contractRateCapPaise !== 0 &&
                                (payorItem.targetDeltaPaise === 0 ||
                                  payorItem.targetDeltaPaise) &&
                                (payorItem.discount === 0 ||
                                  payorItem.discount) &&
                                (payorItem.gst === 0 || payorItem.gst)
                              ) {
                                let foundCashRate = this.foundCashRate(
                                  item,
                                  payorItem
                                );
                                if (!foundCashRate) {
                                  return cogoToast.error(
                                    "No cash rate found for the selected branches."
                                  );
                                }
                                let finalRes = calculateRatesPaise(
                                  foundCashRate,
                                  loadedItemsUpdated[index].hasImplant,
                                  payorItem.contractRateCapPaise,
                                  payorItem.targetDeltaPaise,
                                  payorItem.discount,
                                  payorItem.gst,
                                  payorItem.procedureChargeBeforeDisctPaise
                                );

                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].effectiveBillableRatePaise =
                                  finalRes.effectiveBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].finalBillableRatePaise =
                                  finalRes.finalBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].procedureChargeAfterDisctPaise =
                                  finalRes.procedureChargeAfterDisctPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].specialLessPaise = finalRes.specialLessPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostNetPaise =
                                  finalRes.implantCostNetPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostShownPaise =
                                  finalRes.implantCostShownPaise;
                              }

                              this.setState({
                                loadedItems: loadedItemsUpdated,
                                changed: true,
                              });
                            }}
                          />
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup vertical>
                          <Tag minimal large intent="primary" multiline>
                            {indianRupee(payorItem.finalBillableRatePaise, 2)}
                          </Tag>
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup>
                          <NumericInput
                            style={{ width: "6em" }}
                            value={
                              payorItem.procedureChargeBeforeDisctPaise
                                ? payorItem.procedureChargeBeforeDisctPaise /
                                  100
                                : 0
                            }
                            buttonPosition="NONE"
                            rightElement={<Tag minimal>₹</Tag>}
                            onValueChange={(number) => {
                              const loadedItemsUpdated = _.clone(
                                this.state.loadedItems
                              );
                              loadedItemsUpdated[index].payorRates[
                                payorIndex
                              ].procedureChargeBeforeDisctPaise = number * 100;

                              if (
                                payorItem.contractRateCapPaise !== 0 &&
                                (payorItem.targetDeltaPaise === 0 ||
                                  payorItem.targetDeltaPaise) &&
                                (payorItem.discount === 0 ||
                                  payorItem.discount) &&
                                (payorItem.gst === 0 || payorItem.gst)
                              ) {
                                let foundCashRate = this.foundCashRate(
                                  item,
                                  payorItem
                                );
                                if (!foundCashRate) {
                                  return cogoToast.error(
                                    "No cash rate found for the selected branches."
                                  );
                                }
                                let finalRes = calculateRatesPaise(
                                  foundCashRate,
                                  loadedItemsUpdated[index].hasImplant,
                                  payorItem.contractRateCapPaise,
                                  payorItem.targetDeltaPaise,
                                  payorItem.discount,
                                  payorItem.gst,
                                  payorItem.procedureChargeBeforeDisctPaise
                                );

                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].effectiveBillableRatePaise =
                                  finalRes.effectiveBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].finalBillableRatePaise =
                                  finalRes.finalBillablePaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].procedureChargeAfterDisctPaise =
                                  finalRes.procedureChargeAfterDisctPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].specialLessPaise = finalRes.specialLessPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostNetPaise =
                                  finalRes.implantCostNetPaise;
                                loadedItemsUpdated[index].payorRates[
                                  payorIndex
                                ].implantCostShownPaise =
                                  finalRes.implantCostShownPaise;
                              }

                              this.setState({
                                loadedItems: loadedItemsUpdated,
                                changed: true,
                              });
                            }}
                          />
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup vertical>
                          <Tag minimal large intent="primary" multiline>
                            {indianRupee(
                              payorItem.procedureChargeAfterDisctPaise,
                              2
                            )}
                          </Tag>
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup vertical>
                          <Tag minimal large intent="primary" multiline>
                            {indianRupee(payorItem.specialLessPaise, 2)}
                          </Tag>
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup
                          vertical
                          style={
                            this.state.loadedItems[index]?.hasImplant
                              ? {}
                              : {
                                  opacity: 0.5,
                                }
                          }
                        >
                          <Tag minimal large intent="primary" multiline>
                            {indianRupee(payorItem.implantCostNetPaise, 2)}
                          </Tag>
                        </ControlGroup>
                      </td>
                      <td>
                        <ControlGroup
                          vertical
                          style={
                            this.state.loadedItems[index]?.hasImplant
                              ? {}
                              : {
                                  opacity: 0.5,
                                }
                          }
                        >
                          <Tag minimal large intent="primary" multiline>
                            {indianRupee(payorItem.implantCostShownPaise, 2)}
                          </Tag>
                        </ControlGroup>
                      </td>
                      <td>
                        <Button
                          icon="trash"
                          intent="danger"
                          onClick={() =>
                            this.removePayorItem(index, payorIndex)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Button
              interactive
              style={{ marginTop: "10px" }}
              onClick={() => {
                item.payorRates.push({
                  payorAlias: "",
                  entityName: "",
                  branches: [],
                  contractRateCapPaise: 0,
                  targetDeltaPaise: 0,
                  effectiveBillableRatePaise: 0,
                  discount: 0,
                  finalBillableRatePaise: 0,
                  procedureChargeBeforeDisctPaise: 0,
                  procedureChargeAfterDisctPaise: 0,
                  specialLessPaise: 0,
                  implantCostNetPaise: 0,
                  implantCostShownPaise: 0,
                  gst: 0,
                });

                this.setState({ loadedItems: this.state.loadedItems });
              }}
            >
              Add
            </Button>

            <Button
              style={{ marginTop: "10px" }}
              interactive
              onClick={() => {
                item.payorRates.map((payorItem) => {
                  if (payorItem.contractRateCapPaise === 0) {
                    return cogoToast.error(
                      "Please enter the contract rate cap for all payors"
                    );
                  }
                  if (payorItem.targetDeltaPaise == null) {
                    return cogoToast.error(
                      "Please enter the target delta for all payors"
                    );
                  }
                  if (payorItem.discount == null) {
                    return cogoToast.error(
                      "Please enter the discount for all payors"
                    );
                  }
                  if (payorItem.gst == null) {
                    return cogoToast.error(
                      "Please enter the gst for all payors"
                    );
                  }
                  this.update(item);
                });
              }}
            >
              Save Details
            </Button>
          </Card>
          <Dialog
            title="Are you sure you want to continue?"
            isOpen={this.state.openDailog}
            onClose={() => this.setState({ openDailog: false })}
          >
            <div className={Classes.DIALOG_FOOTER}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  marginTop: "10px",
                }}
              >
                <Button
                  style={{ marginRight: "5px" }}
                  className={Classes.DIALOG_CLOSE_BUTTON}
                  intent="primary"
                  text="No"
                  onClick={() => {
                    this.setState({ openDailog: false });
                  }}
                />
                <Button
                  className={Classes.DIALOG_FOOTER_ACTIONS}
                  intent="primary"
                  text="Yes"
                  onClick={() => {
                    this.setState({ openDailog: false });
                    this.delete(this.state.loadedItems[index]._id);
                  }}
                />
              </div>
            </div>
          </Dialog>
        </Collapse>
      </div>
    ));
  };

  renderList = () => {
    return (
      <div style={{ overflow: "auto" }}>
        <ReactList
          pageSize={500}
          itemRenderer={(index, key) => {
            let each = this.state.loadedItems[index];
            return (
              <div key={`${key}__${each.updatedAt}`}>
                <MasterEntity
                  indexContentName={this.props.indexContentName}
                  displayTitle={this.props.displayTitle}
                  entityType={this.props.entityType}
                  isBusy={this.state.isBusy}
                  data={each}
                  sites={this.state.loadedSites}
                  docs={this.state.loadedDocs}
                  key={`${key}__${each.updatedAt}__${each._id}`}
                  onUpdate={(payload) => {
                    this.update(payload);
                  }}
                  onDelete={() => {
                    this.delete(each._id);
                  }}
                  keepCollapsed={this.props.keepCollapsed}
                />
              </div>
            );
          }}
          length={this.state.loadedItems.length}
          type="simple"
        />
      </div>
    );
  };
  renderTable = (entity) => {
    return (
      <div style={{ overflow: "auto" }}>
        <ReactList
          itemsRenderer={(items, ref) => {
            return (
              <table
                className="bp3-html-table bp3-compact bp3-html-table-bordered bp3-html-table-striped"
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "95vw",
                }}
              >
                <thead>
                  <tr>{this.renderTableHeaders(entity)}</tr>
                </thead>{" "}
                <tbody ref={ref}>{items} </tbody>
              </table>
            );
          }}
          itemRenderer={(index, key) => {
            let each = this.state.loadedItems[index];

            return (
              <MasterRow
                entity={entity}
                key={`${key}__${each._id}__${each.updatedAt}`}
                isBusy={this.state.isBusy}
                data={each}
                sites={this.state.loadedSites}
                docs={this.state.loadedDocs}
                entityType={this.props.entityType}
                columns={this.props.columns}
                onUpdate={(payload) => {
                  this.update(payload);
                }}
                onDelete={() => {
                  this.delete(each._id);
                }}
                copyPayload={this.state.copyPayload}
                onCopy={(copyPayload) =>
                  this.setState({ copyPayload: copyPayload })
                }
              />
            );
          }}
          length={this.state.loadedItems.length}
          type="simple"
        ></ReactList>
      </div>
    );
  };
  renderTableHeaders = (entity) => {
    let headers = this.props.columns;
    if (["sxBooking"].includes(this.props.entityType)) {
      headers = [...headers];
    } else if (["sxSurgeonSchedule"].includes(this.props.entityType)) {
      headers = [...headers, <Icon icon="endorsed" />];
    } else if (["sxPriceMaster"].includes(this.props.entityType) && !entity) {
      headers = [
        "Cash Rate[+]",
        "Branch(es)",
        "Procedure",
        "Implant",
        "Anaesthesia",
        "Tissue",
        "GST",
      ];
    } else if (entity === "sxPriceMasterTable") {
      headers = [
        "Payor",
        "Alias",
        "Branch(es)",
        "Contract Rate Cap",
        "Target Delta(Cash)",
        "Effective Billable Rate",
        "Discount % Required",
        "GST",
        "Final Billable Total",
        "Procedure Charge(Before Disct)",
        "Procedure Charge(After Disct)",
        "Special Less",
        "Implant Cost Net",
        "Implant Cost Shown",
        "Action",
      ];
    } else {
      headers = [
        ...headers,
        <Icon icon="endorsed" />,
        <Icon icon="chat" />,
        <Icon icon="folder-open" />,
        <Icon icon="info-sign" />,
      ];
    }
    return headers.map((each) => {
      return <th>{each}</th>;
    });
  };
  renderGridTopBar = () => {
    if (this.props.renderType === "GRID") {
      return (
        <ControlGroup>
          <SxReportTopBar
            entityType={this.props.entityType}
            sites={this.state.loadedSites}
            docs={this.state.loadedDocs}
            onDataLoad={(data) => this.setState({ loadedItems: data })}
          />
        </ControlGroup>
      );
    }
  };
  renderLedgerTopBar = () => {
    return (
      <div>
        <LedgerSearchTopBar
          sites={this.state.loadedSites}
          onDataLoad={(data) => this.setState({ loadedItems: data })}
        />
      </div>
    );
  };
  renderEntityTypeBar = () => {
    if (
      this.props.entityType === "sxBooking" &&
      this.props.renderType === "TABLE"
    ) {
      return (
        <Card className="dark__bg" elevation={Elevation.FOUR}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <ControlGroup>
              <SxSearch
                loadedSites={this.state.loadedSites}
                loadedDocs={this.state.loadedDocs}
                onDataLoad={(data) =>
                  this.setState({
                    loadedItems: data,
                  })
                }
              />
            </ControlGroup>

            <ControlGroup>
              {" "}
              <Tag large minimal>
                Create New
              </Tag>
              <Button
                disabled={this.state.isBusy}
                outlined
                loading={this.state.isCreatingNew}
                icon="add"
                onClick={() => this.new()}
              />
            </ControlGroup>
          </div>
        </Card>
      );
    }
    return (
      <Card className="dark__bg" elevation={Elevation.FOUR}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          {this.props.entityType === "sxSurgeonSchedule" ||
          this.props.entityType === "sxPriceMaster" ? null : (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <Tag large intent="primary" icon={this.props.icon}>
                {this.props.displayTitle}
              </Tag>
              {this.props.renderType === "GRID" ? (
                <>{this.renderGridTopBar()}</>
              ) : (
                <>
                  {this.props.entityType === "ledger" ? (
                    <>{this.renderLedgerTopBar()}</>
                  ) : (
                    <ControlGroup>
                      <InputGroup
                        leftIcon="search"
                        disabled={this.state.isBusy}
                        value={this.state.searchText}
                        onChange={(event) =>
                          this.setState({ searchText: event.target.value })
                        }
                      />
                      {["item", "prices"].includes(this.props.entityType) ? (
                        <>
                          <Tag minimal large>
                            Filter
                          </Tag>
                          <SingleSelectWrapper
                            showSelectProp={true}
                            items={["ALL", "CURRENT"]}
                            selectedItem={this.state.showAll}
                            onChange={(item) =>
                              this.setState({ showAll: item })
                            }
                          />
                        </>
                      ) : null}
                      {this.props.entityType === "item" &&
                      this.props.renderType === "TABLE" ? (
                        <>
                          <Tag
                            large
                            interactive
                            onClick={() => {
                              this.setState({
                                isPharmacy: !this.state.isPharmacy,
                              });
                            }}
                            minimal={!this.state.isPharmacy}
                            intent={this.state.isPharmacy ? "success" : "none"}
                          >
                            {this.state.isPharmacy
                              ? "Show Pharmacy Items"
                              : "Filter for Pharmacy Items"}
                          </Tag>
                          <Tag
                            large
                            interactive
                            onClick={() => {
                              this.setState({
                                isOptical: !this.state.isOptical,
                              });
                            }}
                            minimal={!this.state.isOptical}
                            intent={this.state.isOptical ? "success" : "none"}
                          >
                            {this.state.isOptical
                              ? "Show Optical Items"
                              : "Filter for Optical Items"}
                          </Tag>
                        </>
                      ) : null}
                      {["materialRequests", "purchaseOrder"].includes(
                        this.props.entityType
                      ) ? (
                        <>
                          <Tag minimal large>
                            Filter
                          </Tag>
                          <SingleSelectWrapper
                            showSelectProp={true}
                            items={[
                              "ALL",
                              "DRAFT",
                              "SUBMITTED",
                              "FULFILLED",
                              "CANCELLED",
                            ]}
                            selectedItem={this.state.showAll}
                            onChange={(item) =>
                              this.setState({ showAll: item })
                            }
                          />
                        </>
                      ) : null}
                      <Button
                        loading={this.state.isSearching}
                        icon="arrow-right"
                        intent="success"
                        disabled={this.state.isBusy}
                        onClick={() => this.search()}
                      />
                    </ControlGroup>
                  )}
                </>
              )}
            </div>
          )}
          {this.props.entityType === "sxSurgeonSchedule" ? (
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag
                large
                intent="primary"
                icon={this.props.icon}
                onRemove={() => {
                  this.setState({
                    surgeonId: null,
                    surgeonName: null,
                    selectedSurgeon: null,
                  });
                }}
              >
                Surgeon
              </Tag>

              <SingleIDSelectWrapper
                showSelectProp={true}
                width="200px"
                items={this.state.loadedDocs.map((each) => {
                  return {
                    ...each,
                    searchName: `${each.shortcode || ""} | ${each.name}`,
                  };
                })}
                selectedItem={this.state.selectedSurgeon}
                labelKey="searchName"
                onChange={(item) => {
                  this.setState({
                    surgeonId: item._id,
                    surgeonName: item.name,
                    selectedSurgeon: item,
                    changed: true,
                  });
                }}
              />

              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ scheduledSite: "" });
                }}
              >
                Site
              </Tag>

              <SingleSelectWrapper
                showSelectProp={true}
                items={this.state.loadedSites}
                selectedItem={this.state.scheduledSite}
                onChange={(item) =>
                  this.setState({ scheduledSite: item, changed: true })
                }
              />

              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ validRange: [] });
                }}
              >
                Date Range:
              </Tag>
              <DateRangeInput
                value={this.state.validRange ? this.state.validRange : []}
                formatDate={(date) => niceDate(date)}
                parseDate={(str) => new Date(str)}
                // minDate={new Date(2019, 0, 1)}
                // maxDate={new Date(2030, 0, 1)}
                allowSingleDayRange
                contiguousCalendarMonths={false}
                onChange={(value) => this.setState({ validRange: value })}
              />
              <Button
                loading={this.state.isSearching}
                icon="arrow-right"
                intent="success"
                disabled={this.state.isBusy}
                onClick={() => this.search()}
              />
            </ControlGroup>
          ) : null}
          {this.props.entityType === "sxPriceMaster" ? (
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag
                large
                intent="primary"
                icon={this.props.icon}
                onRemove={() => {
                  this.setState({
                    surgeryName: "",
                  });
                }}
              >
                Surgery Name
              </Tag>

              <InputGroup
                fill
                value={this.state.surgeryName}
                onChange={(event) => {
                  this.setState({
                    surgeryName: event.target.value,
                    changed: true,
                  });
                }}
              />

              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ panelSite: "" });
                }}
              >
                Site
              </Tag>

              <SingleSelectWrapper
                showSelectProp={true}
                items={this.state.loadedSites}
                selectedItem={this.state.panelSite}
                onChange={(item) =>
                  this.setState({ panelSite: item, changed: true })
                }
              />

              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ panelName: "", panelObject: null });
                }}
              >
                Panel Name
              </Tag>
              <td>
                <AsyncSelWrap
                  showSelectProp={false}
                  placeholder="Search..."
                  searching={this.state.searching}
                  items={this.state.searchResults.map((each) => {
                    return {
                      ...each,
                      item: each.entityName,
                      itemName: each.entityName,
                    };
                  })}
                  selectedItem={this.state.panelObject}
                  update={(item) => this.searchPanel(item)}
                  onChange={(item) => {
                    this.setState({
                      panelName: item.entityName,
                      panelObject: item,
                    });
                  }}
                />
              </td>
              <Button
                loading={this.state.isSearching}
                icon="arrow-right"
                intent="success"
                disabled={this.state.isBusy}
                onClick={() => this.search()}
              />
            </ControlGroup>
          ) : null}
          <>
            {this.props.renderType === "GRID" ||
            this.props.entityType === "sxSurgeonSchedule" ||
            this.props.entityType === "sxPriceMaster" ? null : (
              <ControlGroup>
                <Tag large minimal>
                  Sort
                </Tag>
                {this.props.entityType === "ledger" ? null : (
                  <>
                    <Button
                      disabled={!this.state.loadedItems.length}
                      icon="sort-alphabetical"
                      onClick={() => {
                        let list = this.state.loadedItems;
                        let sortedList;
                        if (this.props.entityType === "prices") {
                          sortedList = list.sort((a, b) =>
                            a.itemName.localeCompare(b.itemName)
                          );
                        } else if (this.props.entityType === "budget") {
                          sortedList = list.sort((a, b) =>
                            a.category.localeCompare(b.category)
                          );
                        } else {
                          sortedList = list.sort((a, b) =>
                            a.entityName.localeCompare(b.entityName)
                          );
                        }

                        this.setState({ loadedItems: sortedList });
                      }}
                    />
                    <Button
                      disabled={!this.state.loadedItems.length}
                      icon="sort-alphabetical-desc"
                      onClick={() => {
                        let list = this.state.loadedItems;
                        let sortedList;
                        if (this.props.entityType === "prices") {
                          sortedList = list.sort(
                            (a, b) => -1 * a.itemName.localeCompare(b.itemName)
                          );
                        } else {
                          sortedList = list.sort(
                            (a, b) =>
                              -1 * a.entityName.localeCompare(b.entityName)
                          );
                        }

                        this.setState({ loadedItems: sortedList });
                      }}
                    />
                  </>
                )}
                <Button
                  disabled={!this.state.loadedItems.length}
                  icon="time"
                  onClick={() => {
                    let list = this.state.loadedItems;
                    let sortedList = list.sort(
                      (a, b) => -1 * a.updatedAt.localeCompare(b.updatedAt)
                    );
                    this.setState({ loadedItems: sortedList });
                  }}
                />

                <Tag large minimal>
                  Create New
                </Tag>
                <Button
                  disabled={this.state.isBusy}
                  outlined
                  loading={this.state.isCreatingNew}
                  icon="add"
                  text={`New ${_.upperFirst(
                    _.lowerCase(this.props.displayTitle)
                  )}`}
                  onClick={() => this.new()}
                />
              </ControlGroup>
            )}
            {this.props.entityType === "sxSurgeonSchedule" ||
            this.props.entityType === "sxPriceMaster" ? (
              <ControlGroup>
                <Tag large minimal>
                  Create New
                </Tag>
                <Button
                  disabled={this.state.isBusy}
                  outlined
                  loading={this.state.isCreatingNew}
                  icon="add"
                  onClick={() => this.new()}
                />
              </ControlGroup>
            ) : null}
          </>
        </div>
      </Card>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="padding__20">
          <NonIdealState
            icon={<Spinner />}
            title={`Loading ${this.props.displayTitle}s...`}
            description={`Please wait while we load currently saved  ${this.props.displayTitle}s`}
          />
        </div>
      );
    }
    return (
      <div className="padding__20">
        {this.renderEntityTypeBar()}
        {this.state.showNewLedgerCreator ? (
          <LedgerCreator
            onCreate={() => this.setState({ showNewLedgerCreator: false })}
          />
        ) : null}
        {this.renderListOrTable()}
      </div>
    );
  }
}

export default inject("authStore")(observer(withRouter(SearchDisplayHOC)));
